import request from '@/utils/http'

const BASE_URL = "https://204910013.xyz/";
// const BASE_URL = "http://localhost:8080/";

export const postComment = (postCommentData) => {
    return request.requestPost(BASE_URL+"portal/comment/post",postCommentData)
};

export const delComment = (id) => {
    const delCommentData = {
        id
    }
    return request.requestPost(BASE_URL+"portal/comment/del",delCommentData)
};

export const listByUserId = (userId,pageNum,pageSize) => {
    const CommentListData = {
        userId,
    }
    return request.requestPost(BASE_URL+"portal/comment/listByUserId?pageNum="+pageNum+"&pageSize="+pageSize,CommentListData)
};

export const listByArticleId = (articleId,pageNum,pageSize) => {
    const CommentListData = {
        articleId,
    }
    return request.requestPost(BASE_URL+"portal/comment/listByArticleId?pageNum="+pageNum+"&pageSize="+pageSize,CommentListData)
};

